import * as React from "react";
import { motion } from "framer-motion";

const sleep = async (ms) =>
  await new Promise((resolve) => setTimeout(resolve, ms));

function Dot() {
  return (
    <motion.div
      style={{
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        margin: 10,
        backgroundColor: "transparant",
      }}
    />
  );
}

function FloatingDiv({ delay, children }) {
  return (
    <motion.div
      style={{
        width: "100%",
        height: "100%",
        borderRadius: "50%",
        margin: 10,
        backgroundColor: "transparant",
        cursor: "pointer",
      }}
      animate={["initial"]}
      // whileHover={["grow"]}
      variants={{
        grow: {
          scale: 1.1,
        },
        rotate: {
          rotate: [null, -5, 5, 0],
          transition: {
            // delay,
            duration: 10,
            // repeat: Infinity,
            // repeatDelay: 0.2,
            // repeatType: "reverse"
          },
        },
        initial: {
          y: [-20, 20],
          rotate: 0,
          transition: {
            delay,
            duration: 2,
            repeat: Infinity,
            // repeatDelay: 0.2,
            repeatType: "reverse",
          },
        },
      }}
    >
      {children}
    </motion.div>
  );
}

export const CustomMotionComponent = ({ children, float }) => {
  if (float) {
    return <FloatingDiv delay={0.3}>{children}</FloatingDiv>;
  } else {
    return (
      <motion.div
        initial={{ y: 50, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5, ease: "easeInOut" }}
      >
        {children}
      </motion.div>
    );
  }
};
export default CustomMotionComponent;